import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout"))
);

const AdminLogs = Loadable(lazy(() => import("src/pages/admins_logs/view")));
const AdminsPage = Loadable(lazy(() => import("../pages/admins/admins/view")));
const PrivilegesPage = Loadable(
  lazy(() => import("../pages/admins/privileges/view"))
);

// authentication
const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login"))
);

const ForgotPassword = Loadable(
  lazy(() => import("../views/authentication/auth/ForgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("src/views/authentication/auth/ResetPassword"))
);

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance"))
);
const Advocacy = Loadable(lazy(() => import("../pages/advocacy/view")));
const AdvocacyCategory = Loadable(
  lazy(() => import("../pages/advocacy_category/view"))
);
const InPressCategory = Loadable(
  lazy(() => import("../pages/in_press_category/view"))
);

const Political_mission_category = Loadable(
  lazy(() => import("../pages/political_mission_category/view"))
);
const Political_mission = Loadable(
  lazy(() => import("../pages/political_mission/view"))
);
const Publication = Loadable(lazy(() => import("../pages/publication/view")));

const InPress = Loadable(lazy(() => import("../pages/in_press/view")));
const SocialInitiatives = Loadable(
  lazy(() => import("../pages/social_Initiatives/view"))
);

const Settings = Loadable(lazy(() => import("../pages/settings/view")));
const ContactForm = Loadable(lazy(() => import("../pages/contactForm/view")));
const LegalInformation = Loadable(
  lazy(() => import("../pages/settings/legal_information"))
);
const SEO = Loadable(lazy(() => import("../pages/seo/view")));
const Gallery = Loadable(lazy(() => import("../pages/gallery/view")));
const RelatedSocialInitiatives = Loadable(
  lazy(() => import("../pages/related_social_Initiatives/view"))
);
const ChangePassword = Loadable(
  lazy(() => import("../pages/change_password/view"))
);

let data = getLocalStorage(dataLocalStorage.privileges);

const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      {
        path: "/",
        exact: true,
        element: (
          <Navigate
            to={
              data["1"]?.access_read == 1
                ? RouterName.admins.admins
                : data["2"]?.access_read == 1
                ? RouterName.advocacy.advocacy
                : data["3"]?.access_read == 1
                ? RouterName.InPress.InPress
                : data["4"]?.access_read == 1
                ? RouterName.politicalMission.politicalMission
                : data["5"]?.access_read == 1
                ? RouterName.publication.publication
                : data["6"]?.access_read == 1
                ? RouterName.socialInitiatives.socialInitiatives
                : data["7"]?.access_read == 1
                ? RouterName.settings.settings
                : data["8"]?.access_read == 1
                ? RouterName.settings.SEO
                : data["9"]?.access_read == 1
                ? RouterName.contact.contact
                : "/404"
            }
          />
        ),
      },

      {
        path: RouterName.gallery.gallery,
        exact: true,
        element: <Gallery />,
      },
      {
        path: RouterName.related_social_initiatives.related_social_initiatives,
        exact: true,
        element: <RelatedSocialInitiatives />,
      },
      data["2"]?.access_read == 1 && {
        path: RouterName.advocacy.advocacyCategory,
        exact: true,
        element: <AdvocacyCategory />,
      },
      data["2"]?.access_read == 1 && {
        path: RouterName.advocacy.advocacy,
        exact: true,
        element: <Advocacy />,
      },

      data["3"]?.access_read == 1 && {
        path: RouterName.InPress.InPressCategory,
        exact: true,
        element: <InPressCategory />,
      },
      data["3"]?.access_read == 1 && {
        path: RouterName.InPress.InPress,
        exact: true,
        element: <InPress />,
      },

      data["4"]?.access_read == 1 && {
        path: RouterName.politicalMission.politicalMissionCategory,
        exact: true,
        element: <Political_mission_category />,
      },
      data["4"]?.access_read == 1 && {
        path: RouterName.politicalMission.politicalMission,
        exact: true,
        element: <Political_mission />,
      },

      data["5"]?.access_read == 1 && {
        path: RouterName.publication.publication,
        exact: true,
        element: <Publication />,
      },

      data["6"]?.access_read == 1 && {
        path: RouterName.socialInitiatives.socialInitiatives,
        exact: true,
        element: <SocialInitiatives />,
      },
      data["9"]?.access_read == 1 && {
        path: RouterName.contact.contact,
        exact: true,
        element: <ContactForm />,
      },
      data["7"]?.access_read == 1 && {
        path: RouterName.settings.settings,
        exact: true,
        element: <Settings />,
      },
      data["8"]?.access_read == 1 && {
        path: RouterName.settings.SEO,
        exact: true,
        element: <SEO />,
      },
      data["7"]?.access_read == 1 && {
        path: RouterName.settings.legal_information,
        exact: true,
        element: <LegalInformation />,
      },

      data["1"]?.access_read == 1 && {
        path: RouterName.admins.admins,
        exact: true,
        element: <AdminsPage />,
      },
      data["1"]?.access_read == 1 && {
        path: RouterName.admins.privileges,
        exact: true,
        element: <PrivilegesPage />,
      },

      data["1"]?.access_read == 1 && {
        path: RouterName.admins_logs.admins_logs,
        exact: true,
        element: <AdminLogs />,
      },
      {
        path: RouterName.changePassword.changePassword,
        exact: true,
        element: <ChangePassword />,
      },
      { path: "/404", element: <Error /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.forgotPassword, element: <ForgotPassword /> },
      { path: RouterName.auth.resetPassword, element: <ResetPassword /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
